<div class="b2b-plate-select">
  <label class="form-label" *ngIf="label">
    {{ label }}
    <span class="text-danger" *ngIf="required">*</span>
  </label>

  <div class="input-group mb-2" *ngIf="contractId">
    <span class="input-group-text"><i class="fas fa-search"></i></span>
    <input
      type="text"
      class="form-control"
      placeholder="Buscar placa ou modelo..."
      [(ngModel)]="searchText"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onSearchChange()"
      [disabled]="disabled || loading"
      autocomplete="off" />
    <button
      type="button"
      class="btn btn-outline-secondary"
      *ngIf="searchText"
      (click)="clearSearch()"
      [disabled]="disabled || loading"
      title="Limpar busca">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <select
    class="form-select"
    [(ngModel)]="value"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="disabled || loading || !contractId"
    (ngModelChange)="onSelectChange($event)"
    (blur)="markTouched()">
    <option [ngValue]="''" *ngIf="allowEmpty">{{ emptyLabel }}</option>
    <option *ngFor="let opt of filteredOptions" [ngValue]="opt.plate">{{ opt.label }}</option>
  </select>

  <small class="text-success d-block mt-1" *ngIf="selectedOption && !loading">
    Selecionada: <strong>{{ selectedOption.plate }}</strong>
    <span *ngIf="selectedOption.model"> — {{ selectedOption.model }}</span>
  </small>

  <small class="text-muted d-block mt-1" *ngIf="loading">Carregando placas do contrato...</small>
  <small class="text-danger d-block mt-1" *ngIf="loadError">
    Não foi possível carregar as placas do contrato.
    <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="reload()">Tentar de novo</button>
  </small>
  <small class="text-muted d-block mt-1" *ngIf="!loading && !loadError && contractId && options.length === 0">
    Nenhuma placa vinculada a este contrato.
  </small>
  <small class="text-muted d-block mt-1" *ngIf="!loading && !loadError && contractId && options.length > 0 && filteredOptions.length === 0">
    Nenhuma placa corresponde à busca «{{ searchText }}».
  </small>
</div>
